import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export const IPN = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Start countdown
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    // Parse the IPN data from the URL or body
    const params = new URLSearchParams(location.search);
    const orderTrackingId = params.get('OrderTrackingId');
    const orderMerchantReference = params.get('OrderMerchantReference');
    const orderNotificationType = params.get('OrderNotificationType');

    // Redirect after 10 seconds based on payment status
    const redirectTimeout = setTimeout(() => {
      // If we have valid parameters, assume success, otherwise failure
      if (orderTrackingId && orderMerchantReference && orderNotificationType === 'IPNCHANGE') {
        navigate('/OrderSuccess');
      } else {
        navigate('/OrderFailed');
      }
    }, 10000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimeout);
    };
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded-lg shadow-md text-center">
        <Loader2 className="h-12 w-12 text-pink-500 mx-auto animate-spin" />
        <h2 className="mt-4 text-2xl font-semibold text-gray-800">Processing Payment</h2>
        <p className="mt-2 text-gray-600">Please wait while we confirm your payment...</p>
        <p className="mt-4 text-sm text-gray-500">Redirecting in {countdown} seconds</p>
      </div>
    </div>
  );
}; 